import React from "react";
import PlansCard from "../../../components/plansCard/PlansCard";



const PricingPlan = () => {
  return (
    <PlansCard />
  );
};

export default PricingPlan;